import { useParams } from 'react-router-dom';
import { Button, Hidden, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';
import { useShareDocument_ViewSharedDocumentByIdQuery } from 'queries';
import { Download } from 'ts-react-feather-icons';

import Spinner from 'common/spinner';
import { NotificationSeverity, showAlert } from 'utils/notification-manager';

const useStyles = makeStyles(() => ({
  parentContainer: {
    paddingLeft: '15%',
    paddingRight: '15%',
    marginTop: '50px',
  },
  actionButtonContainer: { marginTop: '35px' },
  parentRoute: {
    color: '#8DA8B2',
    cursor: 'pointer',
  },
  routeIconContainer: {
    verticalAlign: 'middle',
  },
  container: { marginTop: '35px' },
  buttonContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  },
  buttonGroup: {
    marginRight: 'auto',
  },
  buttonIcon: {
    display: 'flex',
    alignItems: 'center',
    padding: '5px',
    justifyContent: 'center',
  },
  button: {
    background: '#44D2F2',
    color: 'white',
    marginRight: '10px',
    marginBottom: '10px',
  },
  selectCheckBoxes: {
    marginTop: '20px',
    display: 'flex',
  },
  selectNoneCheckbox: {
    marginLeft: '15px',
  },
  menuItem: {
    borderBottom: '1px solid #DAE4ED',
  },
  documentGrid: {
    display: 'flex',
    alignContent: 'center',
    justifyContent: 'center',
    background: 'white',
    height: '100vh',
  },
  document: {
    background: '#F0F3F6',
    height: '75%',
    width: '85%',
    textAlign: 'center',
    margin: 'auto',
  },
}));

export default function ViewDocument() {
  const classes = useStyles();
  const { id } = useParams<Record<string, string>>();
  const { data: viewSharedDocumentData, loading: viewSharedDocumentLoading } =
    useShareDocument_ViewSharedDocumentByIdQuery({
      variables: { id },
      onError: (e) => {
        showAlert({
          message: 'Error viewing shared document: ' + e.message,
          severity: NotificationSeverity.ERROR,
        });
      },
    });

  if (viewSharedDocumentLoading || !viewSharedDocumentData) {
    return <Spinner />;
  }

  return (
    <div className={classes.parentContainer}>
      <Typography variant="h4">{viewSharedDocumentData.data.name}</Typography>
      <div className={classes.actionButtonContainer}>
        <div className={classes.container}>
          <div className={classes.buttonContainer}>
            <div className={classes.buttonGroup}>
              <Button
                className={clsx(classes.button)}
                variant="contained"
                size="small"
                onClick={() => window.open(viewSharedDocumentData.data.url, '_blank')}
              >
                <div className={classes.buttonIcon}>
                  <Download size={20} />
                </div>
                <Hidden mdDown>
                  <Typography>Download</Typography>
                </Hidden>
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className={classes.documentGrid}>
        <div className={classes.document}>
          <img src={viewSharedDocumentData.data.url} alt="Shared" />
        </div>
      </div>
    </div>
  );
}
